export const drawerTypes = {
  edit: 'edit',
};